import type { JwtPayload } from './types';

export const IF_EXTERNAL_USER_ID_CLAIM = 'ifExternalUserId';
export const IF_CLIENT_ID_CLAIM = 'ifClientId';
export const AUTH0_ORGANIZATION_ID_CLAIM = 'org_id';
export const GIVEN_NAME_CLAIM = 'given_name';
export const FAMILY_NAME_CLAIM = 'family_name';

export const parseTokenPayload = (token: string): JwtPayload | null => {
  try {
    const encodedPayload = token.split('.')[1];

    if (!encodedPayload) {
      return null;
    }

    const base64 = encodedPayload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');

    return JSON.parse(atob(padded)) as JwtPayload;
  } catch {
    return null;
  }
};

export const getNamespacedClaim = (
  payload: JwtPayload | null,
  claimName: string,
): string | null => {
  if (!payload) {
    return null;
  }

  const directValue = payload[claimName];

  if (typeof directValue === 'string' && directValue.length > 0) {
    return directValue;
  }

  const namespacedEntry = Object.entries(payload).find(
    ([key, value]) =>
      key.endsWith(`/${claimName}`) && typeof value === 'string' && value.length > 0,
  );

  return (namespacedEntry?.[1] as string | undefined) ?? null;
};

export const parseTokenExpiry = (payload: JwtPayload | null): number | null => {
  try {
    if (payload?.exp) {
      return payload.exp * 1000;
    }

    return null;
  } catch {
    return null;
  }
};
